export default __webpack_public_path__ + "static/media/iconLocation.6a5b568d.svg";